import React from 'react';

//Routing
import { BrowserRouter as Router, Routes, Route  } from 'react-router-dom';

//Components
import Header from './components/Header';
import Toast from './components/Toast';
import Home from './views/Home';
import Organization from './views/Organization';
import Dashboard from './views/DashboardSimple';
import Notifications from './views/Notifications';
import NotFound from './views/NotFound';

//Context
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';
import { EndDateModalProvider } from './contexts/EndDateModalContext';
import { SpinnerProvider } from './contexts/SpinnerContext';

const App = () => {

  return (
    <ThemeProvider>
      <SpinnerProvider>
        <ToastProvider>
          <EndDateModalProvider>
            <Router>
              <Header/>
                <Routes>
                  <Route path='/' element={<Home />}/>
                  <Route path='dashboard' element={<Dashboard />}/>
                  <Route path='notifications' element={<Notifications />}/>
                  <Route path='organization/:organizationId' element={<Organization />}/>
                  <Route path='*' element={<NotFound />}/>
                </Routes>
              <Toast />
            </Router>
          </EndDateModalProvider>
        </ToastProvider>
      </SpinnerProvider>
    </ThemeProvider>
  );
}

export default App;
